import React from "react";

function HowitWorks() {
  return (
    <div className="container text-left grand_parent_div_text faqs_div">
      <h2 className="">
        Q# Transaction was successfull but I don't see NFT on the marketplace
      </h2>
      <p>
        <b>Answer:</b> It could be for 2 reasons, one is your internet issue
        while minting or the BSC network might be congested. Try minting after a
        few minutes with a good internet connection.
      </p>

      <h2 className="">Q# why my art is not on the home page?</h2>
      <p>
        <b>Answer:</b> the arts are on the home page are curated and approved by
        our team. not every piece of art are can be on
      </p>

      <h2 className="">Q# I don't have a meta mask account, how to get one?</h2>
      <p>
        <b>Answer:</b> Please follow this video:
        https://www.youtube.com/watch?v=GNPz-Dv5BjM
      </p>

      <h2 className="">Q# How to mint my first NFTs?</h2>
      <p>
        <b>Answer:</b> On the top right corner, you will see a "create" button,
        click it. Make sure your wallet is connected to the MMONFT marketplace.
        You will see the NFT create wizard. Please fill the form and hit the
        "Create Item" Button. Wolaaa. You will be able to see your NFT minted
        soon.
      </p>

      <h2 className="">Q# why my art is not on the home page?</h2>
      <p>
        <b>Answer:</b>he arts are on the home page are curated and approved by
        our team. not every piece of art are can be on this needs to be removed
        too
      </p>

      <h2 className="">Q# Which token is used to bid on NFTs?</h2>
      <p>
        <b>Answer:</b> MMO Coine are used to bid on any NFT on MMO NFT
        marketplace
      </p>

      <h2 className="">
        Q# what is the maximum royalty I can set as an artist?
      </h2>
      <p>
        <b>Answer:</b> You can set royalty upto 10% max.
      </p>

      <h2 className="">Q# how much does MMO charges service fees ?</h2>
      <p>
        <b>Answer:</b> We keep 2% of every sale in the marketplace as a service
        fee.
      </p>
    </div>
  );
}

export default HowitWorks;
